<template>
  <b-row style="position:relative">
    <b-col cols="12">
      <b-form @submit.prevent="onOperation(1)" autocomplete="off" ref="bsave">
        <div class="mb-2 position-relative">
          <div class="multiselect-lbl" v-if="shopObject && shopObject.eid">{{$t('Shop')}}</div>
          <multiselect
            v-model="shopObject"
            :options="shopList"
            placeholder="Select shop"
            track-by="eid"
            label="name"
            :multiple="false"
            :translate="false"
          ></multiselect>
        </div>
        <b-form-group class="mb-3">
          <date-range-picker
            :startDate="supplyDate"
            @update="updateSupplyDate"
            :locale-data="locale"
            :maxDate="maxDate"
            opens="right"
            :timePicker="false"
            :ranges="false"
            :singleDatePicker="true"
            :label="$t('Supply Date')"
            style="width: 120px"
          />
        </b-form-group>
        <FloatingLabel
          v-model.number="supply.amount"
          label="Amount"
          size="sm"
          type="number"
          step="0.01"
        />
        <FloatingLabel
          v-model="supply.observations"
          label="Observation"
          autocomplete="false"
          type="textarea"
          size="sm"
        />
        <div style="text-align: right;">
          <b-button
            type="submit"
            variant="success"
            :disabled="!shopObject || !shopObject.eid"
          >{{$t('Save')}}</b-button>
        </div>
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf, successConf } from "@/shared/notifications";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import FloatingLabel from "@/components/FloatingLabel";
import Multiselect from "@/components/multiselect-filters";
import TableFilters from "@/components/TableFilters";
import DateRangePicker from "@/components/calendar-range/DateRangePicker";
import timeFormat from "@/shared/timeFormat";

const TIMESTAMP_FORMAT = "YYYY-MM-DD";

export default {
  components: {
    PaginationSelect,
    DropdownColumns,
    FloatingLabel,
    Multiselect,
    DateRangePicker,
    TableFilters
  },
  name: "EposTransactionDeposit",
  props: ["eshop_id", "shop_name"],
  data: function() {
    return {
      maxDate: new Date(),
      locale: {
        format: timeFormat.datePickerShort, //format of the dates displayed
        firstDay: 1, //ISO first day of week - see moment documenations for details
        showWeekNumbers: true //show week numbers on each row of the calendar
      },

      supplyDate: moment(),
      shopObject: null,
      supply: {
        eid: null,
        eshop_id: null,
        timestamp: null,
        optype: 0,
        amount: "",
        cash_operator_id: null,
        observations: ""
      }
    };
  },
  computed: {
    shopList() {
      return this.$store.getters["cache/shops"];
    }
  },
  mounted() {
    const _this = this;
    Promise.all([this.$store.dispatch("cache/fetch", "shops").catch(e => e)])
      .catch(err => {})
      .finally(() => {
        if (_this.eshop_id != "0" && _this.eshop_id != "") {
          _this.shopObject = {
            eid: this.eshop_id,
            name: this.shop_name
          };
        }
        _this.clear();
      });
  },
  methods: {
    clear() {
      this.supply = {
        eid: null,
        eshop_id: null,
        timestamp: null,
        amount: ""
      };
      this.supply.eshop_id =
        this.shopObject && this.shopObject.eid ? this.shopObject.eid : null;
      this.supply.timestamp = moment()
        .utc()
        .format(TIMESTAMP_FORMAT); //new Date().getTime() * 1e6;
      // this.supply.bank_order_number = moment().format("DD.MM.YYYY");
      this.supplyDate = moment();
    },
    updateSupplyDate(value) {
      this.supply.timestamp = moment(value.startDate).format(TIMESTAMP_FORMAT); //new Date(value.startDate).getTime() * 1e6;
    },
    onOperation(type) {
      // 1 - supply; 2 - withdrawal
      const loader = this.$loading.open({
        container: this.$refs.bsave
      });

      const apiAction = "shopEposTX/create";

      const postData = {};
      postData.shop_id =
        this.shopObject && this.shopObject.eid ? this.shopObject.eid : null;
      // postData.type = type == 1 ? 1 : 2; // 1 - supply; 2 - withdrawal
      postData.timestamp = this.supply.timestamp;
      postData.amount = parseInt(this.supply.amount * 10000);

      // postData.tx_timestamp = new Date().getTime() * 1e6;
      postData.observations = this.supply.observations;
      this.$store
        .dispatch(apiAction, postData)
        .then(resp => {
          this.showSuccessNotification("EPOS deposit created");
          this.clear();
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },

    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep #balance-table-deposit th {
  text-transform: capitalize;
}
</style>




